import { Injectable } from '@angular/core';
import { UpdateSSOUserDetailsFromHeader, UpdateUserMetadataReqBody } from '@app-user-management/models/users.model';
import { UserManageService } from '@app-user-management/services/user-manage/user-manage.service';
import { UserRoleManageService } from '@app-user-management/service/user-role-manage.service';
import { AccessService } from '@app-core/services/access/access.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor(
    private accessService: AccessService,
    private userManageService: UserManageService,
    private userService: UserRoleManageService
  ) {}

  public updateUserMetadata(metadata: any) {
    if (window.self != window.top) {
      const { userMetadata: oldMetadata = {} } = this.accessService.getLoginInfo();
      const userPrefChangedMessage = {
        type: 'user_preferences_changed',
        userPreferences: {
          ...oldMetadata,
          ...metadata,
        },
      };
      window.parent.postMessage(userPrefChangedMessage, '*');

      //for sso users
      const userHash = this.accessService.getLoginInfo()?.userHash || '';
      if (userHash) {
        this.userService
          .updateSSOUser(encodeURIComponent(userHash), new UpdateSSOUserDetailsFromHeader(metadata))
          .pipe(take(1))
          .subscribe(() => {});
      }
      return;
    }
    const params = {
      ...metadata,
    };
    const { loginType = '', userHash = '' } = this.accessService.getLoginInfo();
    //call update sso user if userhash is present
    if (userHash) {
      this.userService
        .updateSSOUser(encodeURIComponent(userHash), new UpdateSSOUserDetailsFromHeader(params))
        .pipe(take(1))
        .subscribe(() => {});
    } else {
      this.userManageService
        .updateUser(this.userId, new UpdateUserMetadataReqBody(params), loginType)
        .pipe(take(1))
        .subscribe(
          () => {},
          () => {}
        );
    }
  }

  get userId() {
    const loginInfo = this.accessService.getLoginInfo();
    return loginInfo?.userId;
  }
}
